<template>
  <div class="container">
    <card>
      <div @click="$router.push('/travelAgency/tripDetail')" v-for="(item,index) in itemList" :key="index">
        <div class="line-item">
            <div class="tit"><div class="name">{{item.name}}</div><txtTag :txtColor="'#FFFFFF'" :bgColor="'#36B374'" :border="'#36B374'">正在出团</txtTag></div>
             <div class="warp">
              <div class="tit"><span class="txt">{{item.time}}</span>{{item.addr}}</div>
            </div>
            <div class="warp">
              <div class="tit">行程单号 : {{item.no}}</div>
              <img class="img" src="@/assets/travelAgency/right.png">
            </div>
        </div>
        <rline></rline>
      </div>
    </card>

  </div>
</template>
<script>
    import txtTag from '../travelAgency/components/txt-tag'
    import rline from '../travelAgency/components/line'
    import card from '../travelAgency/components/card'
    export default {
        components: {
            rline,
            card,
            txtTag
        },

        data () {
            return {
                itemList: [{
                    type: 1,
                    time: '2019-04-03 至 2019-04-03',
                    addr: '昆明市西山区',
                    name: '2019导游风采最佳导游服务奖',
                    no: '201985678456789'
                }, {
                    type: 1,
                    time: '2019-04-03 至 2019-04-03',
                    addr: '昆明市西山区',
                    name: '违反旅行管理条例',
                    no: '201985678456789'
                }, {
                    type: 2,
                    time: '2019-04-03 至 2019-04-03',
                    addr: '昆明市西山区',
                    name: '违反旅行管理条例',
                    no: '201985678456789'
                }]
            };
        },

        computed: {},

        watch: {},

        methods: {

        },

        mounted () {},
        created () {}
    }
</script>
<style scoped lang="less">
  .container {
    height: 100vh;
    background-color: @base-bgcolor;
    padding: 16px 12px;

    .line-item {
      padding: 16px;

        .tit {
          display: flex;
          align-items: center;
          font-size: 14px;

          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          .name{
            margin-right: 12px;
          }
          .txt{
            display: inline-block;
            margin-right: 12px;
          }
        }

        .warp {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 12px;

          .tit {

            font-size: 12px;

            font-weight: 400;
            color: rgba(153, 153, 153, 1);
          }

          .img {
            width: 12px;
            height: 12px;
          }

        }

    }
  }
</style>
